export const calculatePriceBasedOnQuantity = (
  product: IProduct,
  quantity: number,
) => {
  let price = parseFloat((product.preco ?? 0).toString().replace(',', '.'));
  let discountedPrice = price;
  if (product.faixaVolume2 === 0) {
    return {price, discountedPrice};
  }

  for (let i = 2; i <= 5; i++) {
    const volume = product[`faixaVolume${i}`];
    const faixaPrice = product[`kdkg${i}`];
    if (volume && faixaPrice && quantity >= volume) {
      discountedPrice = parseFloat(faixaPrice.toString().replace(',', '.'));
    }
  }

  return {price, discountedPrice};
};
